import Timer from "../gd/task-timer/timer";
import Task from "../model2/task/task";
import Meeting from "../model2/meeting/meeting";
import ModalCreateTimeReport from "./time-report/create/modal-create-time-report";

export type TimeReportForTaskOptions = {
    date?                   : Moment,
    callback?               : callback,
    needMyTimeResponse?     : boolean,
    userId?                 : ID,
    taskMessageId?              : ID    // add time report for message

}

// a meeting has no task messages to report on
export type TimeReportForMeetingOptions = Omit<TimeReportForTaskOptions, 'taskMessageId'>

export default class MyTimeModalsManager {

    constructor() {}

    timeReportForTask(task : Task, options:TimeReportForTaskOptions = {}) {

        // userId -> viewFor user id in my work
        // report time on behalf of someone else (!)

        gd.modal.showV4({
            className   : 'modal-time-report',
            component   : ModalCreateTimeReport,

            params      : {
                task                : task,
                date                : options.date,
                callback            : options.callback,
                needMyTimeResponse  : options.needMyTimeResponse,
                userId              : options.userId,
                taskMessageId       : options.taskMessageId
            }
        });
    }

    // meeting reports default the duration to the meeting length, like the server side guesstimate does
    timeReportForMeeting(meeting : Meeting, options:TimeReportForMeetingOptions = {}) {

        gd.modal.showV4({
            className   : 'modal-time-report',
            component   : ModalCreateTimeReport,

            params      : {
                meeting             : meeting,
                date                : options.date || meeting.startMoment || moment(),
                callback            : options.callback,
                needMyTimeResponse  : options.needMyTimeResponse,
                userId              : options.userId,

                reportedTimeMinutes : meeting.durationMinutes || undefined,
            }
        });
    }

    submitTimer(timer:Timer, minDate:Moment, callback:callback) {

        // the timer's entity is a task or a meeting - the modal accepts exactly one of them
        const entityParams = timer.isMeeting
            ? {meeting : timer.entity}
            : {task    : timer.entity}

        gd.modal.showV4({
            className   : 'modal-time-report',
            component   : ModalCreateTimeReport,

            params: {
                timer           : timer,
                ...entityParams,
                minDate         : minDate,
                // date            : date,
                callback        : callback,

                reportedTimeMinutes : timer.timeInMinutes,
                startMoment         : timer.startEnd.start,
                endMoment           : timer.startEnd.end,
            }
        });
    }




}

// module.exports = MyTimeModalsManager;